export const error = (state = {}, action) => {
    const { error } = action.payload
    if (!error) {
        return state
    }
    if (error.modelState) {
        return error.modelState
    }
    const validationErrors = error.inner?.filter(
        (e) => e.name === 'ValidationError'
    )
    if (validationErrors?.length > 0) {
        return validationErrors.reduce((acc, error) => {
            return { ...acc, [error.path]: error.errors }
        }, {})
    }
    return state
}
